'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { BounceLoader } from 'react-spinners';
import { useTheme } from '@mui/material/styles';
import { useStuckSpinnerReport } from './useStuckSpinnerReport';
export type LoadingProps = {
  /**
   * When true, uses a slightly larger bounce size. Always viewport-centered.
   */
  fullScreen?: boolean;
  /** BounceLoader diameter in px when `fullScreen` is false. */
  size?: number;
  /**
   * Who is holding the screen, rendered as `data-source`. Every spinner in this
   * app looks identical, so without it a stuck one has to be found by guessing
   * at candidates and instrumenting them one at a time.
   */
  source?: string;
};

/**
 * Shared centered bounce loading indicator (react-spinners `BounceLoader`).
 * Use for route transitions and Suspense fallbacks — not MUI `CircularProgress`.
 */
export function Loading(t0) {
  const $ = _c(5);
  const {
    fullScreen: t1,
    size: t2,
    source
  } = t0;
  const fullScreen = t1 === undefined ? false : t1;
  const size = t2 === undefined ? 30 : t2;
  const theme = useTheme();
  const spinnerSize = fullScreen ? 35 : size;
  const container = React.useRef(null);
  useStuckSpinnerReport(source, container);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      position: "fixed",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100vw",
      height: "100vh",
      zIndex: 9999,
      pointerEvents: "none"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== source || $[2] !== spinnerSize || $[3] !== theme.palette.primary.main) {
    t4 = <div ref={container} style={t3}><BounceLoader color={theme.palette.primary.main} aria-label="Loading Spinner" size={spinnerSize} data-testid="loading" data-source={source} /></div>;
    $[1] = source;
    $[2] = spinnerSize;
    $[3] = theme.palette.primary.main;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}